import React, { useContext, useState, useEffect } from 'react'
import { ResourceContext } from '../../../context/resourceContext/ResourceContext'

import {
  Card,
  //   CardActions,
  //   CardContent,
  CardMedia,
  Button,
  Typography
} from '@material-ui/core/'
// import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt'
// import ThumbUpAltOutlined from '@material-ui/icons/ThumbUpAltOutlined'
import DeleteIcon from '@material-ui/icons/Delete'
import DownloadIcon from '@mui/icons-material/Download'
import { saveAs } from 'file-saver'
import videothumbnail from '../../../images/default-video-thumbnail.jpeg'
import moment from 'moment'
import { apiUrl, URL } from '../../../context/constants/constants'
import { Link } from 'react-router-dom'
import ColorizeOutlinedIcon from '@mui/icons-material/ColorizeOutlined'
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined'
// import { likePost, deletePost } from '../../../actions/posts'

const Post = ({ post }) => {
  const {
    resourceState: { resources },
    deleteResource
  } = useContext(ResourceContext)

  const [thumbnail, setThumbnail] = useState('')
  const downloadImage = (post, title) => {
    const url = apiUrl + '/' + post.files[0].filePath
    // window.location.assign(url, '_blank')
    // window.open(url, '_blank')
    saveAs(url, title) // Put your image URL here.
  }

  const handleClick = async (post) => {
    const url = apiUrl + '/' + post.files[0].filePath
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const handleDeleteResource = (resourceId) => {
    deleteResource(resourceId)
  }

  useEffect(() => {
    const fileArray = []
    if (post) {
      if (post.files) {
        post.files.forEach((file) => {
          if (
            file.fileType === 'image/jpeg' ||
            file.fileType === 'image/jpg' ||
            file.fileType === 'image/png'
          ) {
            fileArray.push(apiUrl + '/' + file.filePath)
          } else {
            //console.log(post.videoThumbnail)
            if (post.videoThumbnail && post.videoThumbnail !== '') {
              fileArray.push(apiUrl + '/' + post.videoThumbnail)
            } else {
              fileArray.push(videothumbnail)
            }
          }
        })
      }
      setThumbnail(fileArray.slice(0, 1))
    }
  }, [post])

  return (
    <Card className='card'>
      <div className='buttons'>
        <Button
          onClick={() => {
            if (window.confirm('Are you sure to delete this item?')) {
              handleDeleteResource(post._id)
            }
          }}
        >
          <DeleteIcon />
        </Button>
        {post.videoThumbnail && post.videoThumbnail !== '' ? (
          <Button onClick={() => handleClick(post)}>
            <DownloadIcon />
          </Button>
        ) : (
          <Button onClick={() => downloadImage(post, post.title)}>
            <DownloadIcon />
          </Button>
        )}
      </div>
      <div className='link'>
        {thumbnail !== '' ? (
          <div>
            {thumbnail.map((file) => (
              <div key={file}>
                <CardMedia
                  className='media'
                  image={file}
                  style={{ width: '286px', height: '137px' }}
                  title={post.title}
                />
                <div className='imgCaption'>
                  <div className='fileTitle'>{post.title}</div>
                  <div className='fileCate'>
                    {post.categoryLocation === 'Laser' ? (
                      <CameraAltOutlinedIcon />
                    ) : (
                      <ColorizeOutlinedIcon />
                    )}{' '}
                    {post.categoryLocation}
                  </div>
                  <div className='overlay'>
                    <Typography variant='body2'>
                      {moment(post.createdAt).fromNow()}
                    </Typography>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div>
            <CardMedia className='media' image={videothumbnail} />
            <div className='imgCaption'>
              <div className='overlay'>
                <Typography variant='body2'>
                  {moment(post.createdAt).fromNow()}
                </Typography>
              </div>
            </div>
          </div>
        )}
      </div>
    </Card>
  )
}

export default Post
